export const SkeletonUtils = window.THREE.SkeletonUtils;
